/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PropertyChangeDto
 */
export interface PropertyChangeDto {
    /**
     * Name of the changed property
     * @type {string}
     * @memberof PropertyChangeDto
     */
    propertyName?: string;
    /**
     * Original value before the change
     * @type {string}
     * @memberof PropertyChangeDto
     */
    originalValue?: string;
    /**
     * New value after the change
     * @type {string}
     * @memberof PropertyChangeDto
     */
    newValue?: string;
    /**
     * Type of the property
     * @type {string}
     * @memberof PropertyChangeDto
     */
    propertyType?: string;
}

/**
 * Check if a given object implements the PropertyChangeDto interface.
 */
export function instanceOfPropertyChangeDto(value: object): value is PropertyChangeDto {
    return true;
}

export function PropertyChangeDtoFromJSON(json: any): PropertyChangeDto {
    return PropertyChangeDtoFromJSONTyped(json, false);
}

export function PropertyChangeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyChangeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'propertyName': json['propertyName'] == null ? undefined : json['propertyName'],
        'originalValue': json['originalValue'] == null ? undefined : json['originalValue'],
        'newValue': json['newValue'] == null ? undefined : json['newValue'],
        'propertyType': json['propertyType'] == null ? undefined : json['propertyType'],
    };
}

export function PropertyChangeDtoToJSON(json: any): PropertyChangeDto {
    return PropertyChangeDtoToJSONTyped(json, false);
}

export function PropertyChangeDtoToJSONTyped(value?: PropertyChangeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'propertyName': value['propertyName'],
        'originalValue': value['originalValue'],
        'newValue': value['newValue'],
        'propertyType': value['propertyType'],
    };
}

